export default {
  type: "establishment-internal-order-items",
  storable: {
    type: "products",
    id: null,
  },
  unitOfMeasureUnit: {
    type: "unit-of-measure-units",
    id: null,
  },
  relationshipNames: ["unitOfMeasureUnit", "storable", "internalOrder"],
  delivery_date: null,
  quantity: 1,
};
